import * as React from 'react';
import { connect } from 'react-redux';

export interface VAPSTileProps {
    hasVAP?: boolean,
    productName: string,
    VAPCode: string,
    imageClass: string
}

class VAPSTile extends React.PureComponent<VAPSTileProps> {

    constructor(props) {
        super(props);

        this.addVap = this.addVap.bind(this);
        //{!this.props.hasVAP &&
        //    <div className="buttonSize">
        //        <input type="button" id="addVap" className="addVapButton" name="addVap" value="+"></input>
        //    </div>
        //}
    }

    addVap() {

    }

    public render() {
        return (
            <div className="">
                <div className="row noma align-items-center">
                    <div className="col-4 col-lg-2 nopa align-self-center">
                        <div className={this.props.imageClass}></div>
                    </div>
                    <div className="col-8 col-lg-10 nopa align-self-center">
                        <p className="productName mt-2">{this.props.productName}</p>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(VAPSTile)